import React from "react";
import './NoAuth.css';
import PageRegister from "./PageRegister/PageRegister";
import PageAuth from "./PageAuth/PageAuth";
import logoauth from "../../img/MainMenu/gif300optimazed.gif";

// Компонент LoginControl
class LoginControl extends React.Component {
    // конструктор класса
    constructor(props) {
      super(props);
      this.state = {
        SITE_ADDRESS: "https://launch.artyfact.game",
      }
      
      // Добавляем видимость this для слушателей событий
      this.handleLoginClick = this.handleLoginClick.bind(this);
      this.handleLogoutClick = this.handleLogoutClick.bind(this);
      
      let curUrl = window.location.href;
      //console.log(curUrl);
      let tempUrl = curUrl.indexOf('?') >=0 ? curUrl.split('?')[1] : '';
      let loginKey = '';
      let loginMentor = '';

      //console.log(curUrl);
      if ( curUrl.indexOf('?') >=0 && curUrl.indexOf('&') >= 0 ) {
        loginKey = tempUrl.split('&')[0];
        loginMentor = tempUrl.split('&')[1] ? tempUrl.split('&')[1].trim() : '';
      } else {
        loginKey = tempUrl.trim();
      }
      if (curUrl.indexOf('/r/') > 0 ) {
        loginMentor = `${curUrl.substr(curUrl.indexOf('/r/')+3)}`;
      }
      if (curUrl.indexOf('/token/') > 0) {
        let loginToken = `${curUrl.substr(curUrl.indexOf('/token/') + 7)}`;
        console.log(loginToken);
        
        if(!localStorage.getItem('token')) {
          localStorage.setItem('token', loginToken);
          localStorage.setItem('tokenDefault', loginToken);
          sessionStorage.setItem('SessionTime', new Date());
          sessionStorage.setItem('DefaultToken', loginToken);
        }
        window.open(this.state.SITE_ADDRESS, '_top');
      }

      console.log('Login: ', loginKey);
      console.log('Mentor: ', loginMentor);

      // Устанавливаем по умолчанию значение this.state.isLoggedIn
      this.state = { isLoggedIn: false, reffunc: this.props.refetch, mentor: loginMentor.length > 0 ? loginMentor : '' };

      if (loginKey && loginKey=="login") {
        this.state.isLoggedIn = true;
      }
      if (loginKey && loginKey=="register") {
        this.state.isLoggedIn = false;
      }
      
    }

    componentDidMount() {
      let loginKey = '';
      let curUrl = window.location.href;
      let tempUrl = curUrl.indexOf('?') >=0 ? curUrl.split('?')[1] : '';
      if ( curUrl.indexOf('?') >=0 && curUrl.indexOf('&') >= 0 ) {
        loginKey = tempUrl.split('&')[0];
      } else {
        loginKey = tempUrl.trim();
      }
      if (loginKey=="login" && localStorage.getItem('token')) {
        window.open(this.state.SITE_ADDRESS, '_top');
      }
    }
  
    // Слушатель событий handleLoginClick меняет значение this.state.isLoggedIn на false
    handleLoginClick() {
      this.setState({isLoggedIn: true});
    }
    
    // Слушатель событий handleLoginClick меняет значение this.state.isLoggedIn на false
    handleLogoutClick() {
      this.setState({isLoggedIn: false});
    }
  
    render() {
      
      // Записываем значение this.state.isLoggedIn в переменную isLoggedIn
      const isLoggedIn = this.state.isLoggedIn;
      const reffunc = this.state.reffunc;
      const Agent = this.state.mentor;
      // Созадаем пустую переменную button
      let button = null;
      let logoClass = 'logo-auth';
      
      // В зависимости от условий записываем в переменную button варианты кнопки
      if (isLoggedIn) {      
        button = <LogoutButton onClick={this.handleLogoutClick} />; 
        logoClass = 'logo-auth logo-auth2';
      } else {
        button = <LoginButton onClick={this.handleLoginClick} />;
        logoClass = 'logo-auth';
      }
  
      // Подключаем компонент Greeting с параметром  isLoggedIn и вариант отображении кнопки используя переменную button
      return (     
        <div className="NoAuth main-slide">   
          <img className={logoClass} src={logoauth}/>
          <div className="NoAuthInIn">                  
            <NoAuth refetch={reffunc} isLoggedIn={ isLoggedIn } Agent={ Agent }/>        
            {/*{button}*/}
          </div> 
        </div>         
      );
    }
  }
  
  // Компонент LoginButton - возвращает кнопку Войти
  function LoginButton(props) {
    return (
      <button className="LogButton" onClick={props.onClick}> Registration </button>
    );
  }
  
  // Компонент LogoutButton - возвращает кнопку Выйти
  function LogoutButton(props) {
    return (
      <button className="LogButton" onClick={props.onClick}> Login </button>
    );
  }
  

function NoAuth(props) {    
    const isLoggedIn = props.isLoggedIn;
    const refetch = props.refetch;
    const Agent = props.Agent;
    if (!isLoggedIn) {
        return (                   
          <PageAuth refetch={refetch}/>                   
        )
    } else {
        return (                
          // <PageRegister refetch={refetch} Agent={Agent}/>
          <PageAuth refetch={refetch}/>   
        )
    }
}       

export default LoginControl